import { Link } from 'react-router-dom';
import CardCurve from '../assets/dynamic/card-curve';
import Placeholder from '../assets/placeholder.svg'
import { useState } from 'react';

const Card = ({ color, item }) => {
  const image = `${process.env.PUBLIC_URL}/media/products/${item.category}-${item.collection}.jpeg`;
  const imageClose = `${process.env.PUBLIC_URL}/media/products/${item.category}-${item.collection}-close.jpeg`;
  const [imgSrc, setImgSrc] = useState(image);

  return (
    <div className="card" onMouseEnter={(e) => setImgSrc(imgSrc === image ? imageClose : image)}>
      <Link to={`/${item.collection}/${item.category}`}>
        <img
          alt={`${item.category} from the ${item.collection} collection`}
          className="card-image"
          onError={(e) => setImgSrc(Placeholder)}
          src={imgSrc}
        />
        <h3 className="card-name">{item.name}</h3>
        <CardCurve color={color} />
        <div className="card-ratio"></div>
      </Link>
    </div>
  );
};

export default Card;
